'use strict';

angular.module('mobile-apps')
	.directive('changelog',['$stateParams', 'EntryMain', 'EntryStatus', 'Teams', 'AvailableLanguages', 'Changelog', '$timeout', function($stateParams, EntryMain, EntryStatus, Teams, AvailableLanguages, Changelog, $timeout) {
		return {
			scope:
			{
				deactivateUserFilter: '@', // When set to 'true' the user-filter-icon will not be displayed
				query : '=',
				queryChangeCallback : '&' // Gets called when the query gets changed internally
			},
			templateUrl: 'modules/mobile-apps/views/changelog.client.directive.html',
			link: function (scope, elem, attrs) {

				var dataLimit = 25;

				scope.datePickersOpen = {
					creationDateTo: false,
					creationDateFrom: false
				};
				scope.datePickerMinDate = new Date(Date.now() - 7 * 24*60*60 * 1000);
				scope.datePickerMaxDate = new Date();

				scope.noMoreData = false;

				scope.allLanguages = {};

				// Define how the different change-log-types should be displayed
				var changeTypeDesc = {
					CreateEntry: { 		icon: 'fa-plus-circle', cssclass: 'info', title: 'Created Translation',
						additionalFieldStyles: {
							draft: { 'margin-top': '10px' }
						},
						fields:
						[
							{key: 'description', 	value:	'Description'},
							{key: 'draft', 			value:	'Draft content'},
							{key: 'value', 			value:	'Target content'}
						]},
					UpdateValue: { 		icon: 'fa-pencil', 		cssclass: 'success', 	title: 'Updated Translation', fields:
						[
							{key: 'oldValue', 		value:	'FROM'},
							{key: 'value', 			value:	'TO'}
						]},
					LockEntry: { 		icon: 'fa-lock', 		cssclass: 'default', 	title: 'Locked Translation', fields: []},
					UnlockEntry: { 		icon: 'fa-unlock-alt', 		cssclass: 'default', 	title: 'Unlocked Translation', fields: []},
					UpdateDraft: { 		icon: 'fa-pencil-square-o', 		cssclass: 'warning',	title: 'Updated Draft',	fields:
						[
							{key: 'oldValue', 		value:	'FROM'},
							{key: 'value', 			value:	'TO'}
						]},
					UpdateDraftTm: { 		icon: 'fa-pencil-square-o', 		cssclass: 'warning',	title: 'Translated from TM',	fields:
						[
							{key: 'oldValue', 		value:	'FROM'},
							{key: 'value', 			value:	'TO'}
						]},
					UpdateDescription: { icon: 'fa-info-circle', 	cssclass: 'default',	title: 'Updated Description',fields:
						[
							{key: 'oldValue', 		value:	'FROM'},
							{key: 'value', 			value:	'TO'}
						]},
					UpdateMetadata: { icon: 'fa-info-circle', 	cssclass: 'default',	title: 'Updated Metadata',fields:
						[
							{key: 'oldValue', 		value:	'FROM'},
							{key: 'value', 			value:	'TO'}
						]},
					UpdateStatus: { 		icon: 'fa-pencil-square-o', 		cssclass: 'success',	title: 'Updated Status',
						valueDisplayFunctionFields: ['value', 'oldValue', 'comment', 'oldComment'],
						additionalFieldStyles: {
							comment: { 'margin-top': '10px' }
						},
						valueDisplayFunction: function(value, fieldName) {
							if (['comment', 'oldComment'].indexOf(fieldName) !== -1) {
								// Remove the special text-mention-syntax and leave only name behind
								if (value && value.constructor.name === 'String') {
									return value.replace(/@\[([\s\w\x7f-\xff]+):[0-9a-z-]+\]/gi, '$1');
								} else {
									return '';
								}
							} else {
								// Replace status-id with status-text
								if (!value) {
									return 'New';
								}
								if (EntryStatus.statusInformation.hasOwnProperty(value)) {
									return EntryStatus.statusInformation[value].name;
								}
								return 'unknown';
							}

						},
						fields:
							[
								{key: 'oldValue', 		value:	'FROM'},
								{key: 'value', 			value:	'TO'},
								{key: 'comment', 			value:	'AND COMMENTED'},
								{key: 'oldComment', 		value:	'PREVIOUS COMMENT'}
							]},
					DeleteEntry: { 		icon: 'fa-minus-circle',cssclass: 'danger',	title: 'Deleted Translation', fields: []},
					LinkEntry: { 		icon: 'fa-plus-circle',cssclass: 'success',	title: 'Entry Linked', fields: []},
					UnlinkEntry: { 		icon: 'fa-plus-circle',cssclass: 'success',	title: 'Entry Unlinked', fields: []},
					CreateLanguage: { 	icon: 'fa-plus-circle', cssclass: 'info',title: 'Created Language', fields: []},
					DeleteLanguage: { 	icon: 'fa-minus-circle',cssclass: 'danger',	title: 'Deleted Language', fields: []},
					UpdateLanguage: { 	icon: 'fa-pencil', 		cssclass: 'success', 	title: 'Updated Language', fields: []},
					CreateGroup: { 		icon: 'fa-plus-circle', cssclass: 'info',title: 'Created Group', fields: []},
					CreateTag: { 		icon: 'fa-plus-circle', cssclass: 'info',title: 'Created Tag', fields: []},
					ResetGroup: { 		icon: 'fa-refresh', 	cssclass: 'danger',	title: 'Reset Group', fields: []},
					DeleteGroup: { 		icon: 'fa-minus-circle',cssclass: 'danger', title: 'Deleted Group',	fields: []},
					DeleteTag: { 		icon: 'fa-minus-circle',cssclass: 'danger', title: 'Deleted Tag',	fields: []},
					UpdateTag: { 		icon: 'fa-pencil', 		cssclass: 'success',	title: 'Updated Tag',
						fields: [
							{key: 'oldValue', 			value:	'FROM'}
						]
					},
					AddTagEntry: { 		icon: 'fa-plus-circle', 		cssclass: 'success',	title: 'Entry Tagged',
						fields: [],
						contextOverwrite: {
							'key': 'the ID',
							'tagName': 'with Tag'
						}
					},
					RemoveTagEntry: { 		icon: 'fa-minus-circle', 		cssclass: 'warning',	title: 'Remove Tag Entry',
						fields: [],
						contextOverwrite: {
							'key': 'the ID',
							'tagName': 'from Tag'
						}
					},

					UpdateGroup: { 		icon: 'fa-pencil', 		cssclass: 'success',	title: 'Updated Group',	fields: []},


					CreateGlossaryEntry: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'Create Glossary Entry',	fields: []},
					CreateGlossaryTranslation: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'Create Glossary Translation', fields: []},
					DeleteGlossaryTranslation: { 		icon: 'fa-pencil', 		cssclass: 'danger',	title: 'Delete Glossary Translation',
						fields: [
							{key: 'description', 	    value:	'ENTRY'},
							{key: 'oldValue', 			value:	'TRANSLATION'}
						]},
					DeleteGlossaryEntry: { 		icon: 'fa-pencil', 		cssclass: 'danger',	title: 'Delete Glossary Entry',
						fields: [
							{key: 'description', 	value:	'ENTRY'}
						]
					},
					UpdateGlossaryEntry: { 		icon: 'fa-pencil', 		cssclass: 'success',	title: 'Update Glossary Entry',
						fields: [
							{key: 'description', 	value:	'ENTRY'},
							{key: 'oldValue', 		value:	'FROM'},
							{key: 'value', 			value:	'TO'}
						]},


					APIupload: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'API Upload',	fields: []},
					OrderImport: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'Order Import',	fields:
						[
							{key: 'fileName', 		value:	'Name of imported file'}
						]},
					FileImport: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'File Import',	fields:
						[
							{key: 'fileName', 		value:	'Name of imported file'}
						]},
					AppStoreImport: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'Appstore Import',	fields: []},
					MoveToGroup: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'Move To Group',	fields: [
						{key: 'oldValue', 	value:	'Previous Group'}],
						contextOverwrite: {
							'groupName': 'to Group'
						}},
					XtmImportStart: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'XTM Import Start',	fields: [
							{key: 'description', 	value:	'Description'}
						]},
					XtmImport: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'XTM Import',	fields:[]},
					SdkUpload: { 		icon: 'fa-pencil', 		cssclass: 'info',	title: 'SDK Upload',	fields:[]},
					BackupImport: { icon: 'fa-pencil', cssclass: 'info', title: 'Backup Import', fields: [] },
					UpdateMaxLength: {
						icon: 'fa-pencil',
						cssclass: 'default',
						title: 'Updated Max Length',
						valueDisplayFunctionFields: ['value', 'oldValue'],
						valueDisplayFunction: function(value, fieldName) {
							if (value === '-1') {
								return 'deactivated';
							} if (value === undefined) {
								return 'default';
							}
							return value;
						},
						fields:
							[
								{key: 'value', 			value:	'TO'},
								{key: 'oldValue', 		value:	'FROM'}
							]}
				};

				scope.lastLogDate = null;
				scope.changelogData = [];

				scope.filter = {
					active: {
						type: '_ALL_CHANGES_',
						user: '_ALL_',
						changedLastDays: '_ALL_',
						creationDateFrom: null,
						creationDateTo: null
					},
					selected: {
						type: '_ALL_CHANGES_',
						user: '_ALL_',
						changedLastDays: '_ALL_',
						creationDateFrom: null,
						creationDateTo: null
					},
					options: {
						types: [],
						users: [],
						changedLastDays: []
					}
				};


				/**
				 * Opens the datepicker with the given name
				 * @param datePickerName The datepicker to open
				 */
				scope.openDatePicker = function(datePickerName, event) {
					scope.datePickersOpen[datePickerName] = true;
				};


				/**
				 * Initializes the filter options
				 */
				function initFilters() {

					// Init the default all value
					scope.filter.options.types.push({
						key: '_ALL_',
						title: 'All Types'
					});
					scope.filter.options.types.push({
						key: '_ALL_CHANGES_',
						title: 'All Translation Changes'
					});
					scope.filter.options.users.push({
						key: '_ALL_',
						title: 'All Users'
					});
					scope.filter.options.changedLastDays.push({
						key: '_ALL_',
						title: 'All Days'
					});
					scope.filter.options.changedLastDays.push({
						key: '_CUSTOM_',
						title: 'Custom'
					});

					// Init the changelog types
					for (var type in changeTypeDesc) {
						scope.filter.options.types.push({
							key: type,
							title: changeTypeDesc[type].title
						});
					}

					// Init the changedLastDays
					for (var i=1;i<9;i++) {
						var title = i + ' days ago';
						if (i === 1) {
							title = i + ' day ago';
						}
						scope.filter.options.changedLastDays.push({
							key: i,
							title: title
						});
					}

					// Query the team-members and system-users
					EntryMain._fetchMobileApp($stateParams.mobileAppId, false, function(err, mobileApp) {
						// Add system users
						if (mobileApp.hasOwnProperty('_systemUsers') && angular.isArray(mobileApp._systemUsers)) {
							mobileApp._systemUsers.forEach(function(systemUser) {
								scope.filter.options.users.push({
									key: systemUser._id,
									title: systemUser.displayName
								});
							});
						}

						// Load the team members
						Teams.get({
								teamId: mobileApp.team._id
							},
							function success (response) {
								response.members.forEach(function(member) {
									scope.filter.options.users.push({
										key: member.user._id,
										title: member.user.displayName
									});

								});
							}, function failure (errResponse) {
								console.log(errResponse);
							});

					});
				};


				/**
				 * Applies the current filter options
				 */
				scope.applyFilters = function() {
					scope.changelogData.length = 0;
					scope.lastLogDate = null;

					scope.filter.active = angular.copy(scope.filter.selected);

					scope.fetchMoreData();
				};


				/**
				 * Returns the filter query
				 */
				scope.getQuery = function() {
					var query = angular.copy(scope.query);

					if (scope.filter.active.type !== '_ALL_') {
						query.type = scope.filter.active.type;
					}
					if (scope.filter.active.user !== '_ALL_') {
						query.userId = scope.filter.active.user;
					}
					if (['_ALL_', '_CUSTOM_'].indexOf(scope.filter.active.changedLastDays) === -1) {
						query.changedLastDays = scope.filter.active.changedLastDays;
					} else if (scope.filter.active.changedLastDays === '_CUSTOM_') {
						if (scope.filter.active.creationDateFrom) {
							query.creationDateFrom = scope.filter.active.creationDateFrom;
						}
						if (scope.filter.active.creationDateTo) {
							query.creationDateTo = new Date(scope.filter.active.creationDateTo.getTime()+24*60*60*1000);
						}
					}

					return query;
				};


				/**
				 * Returns additional styles to apply for the field
				 */
				scope.getAdditinalFieldStyles = function(key, fieldData) {
					if (fieldData.hasOwnProperty('additionalFieldStyles') && fieldData.additionalFieldStyles.hasOwnProperty(key)) {
						return fieldData.additionalFieldStyles[key];
					}
					return undefined;
				};


				/**
				 * Display the changelog of the user
		         */
				scope.fetchUserChangelog  = function (userId, userName) {
					scope.query = {
						userId: userId
					};

					if (scope.queryChangeCallback && scope.queryChangeCallback() && angular.isFunction(scope.queryChangeCallback())) {
						scope.queryChangeCallback()(scope.query, {userName: userName});
					}

					scope.changelogData.length = 0;
					scope.lastLogDate = null;
					scope.fetchMoreData();
				};


				/**
				 * Gets the data from server and adds it to view
				 */
				scope.fetchMoreData  = function () {
					scope.lastId = 0;
					if(scope.changelogData && scope.changelogData.length > 0) {
						scope.lastId = scope.changelogData[scope.changelogData.length-1]._id;
					}

					var query = scope.getQuery();

					Changelog.get({
						mobileAppId: $stateParams.mobileAppId,
						query: query,
						limit: dataLimit,
						lastId: scope.lastId
					}, function (response) {
						if(!scope.changelogData) {
							scope.changelogData = [];
						}
						for (var i=0; i<response.length; i++){
							scope.changelogData.push(enrichChangelogEntry(response[i]));
						}

						if (response.length < dataLimit) {
							scope.noMoreData = true;
						} else {
							scope.noMoreData = false;
						}

					}, function (errResponse) {
						console.log(errResponse);
					});

				};


				function enrichChangelogEntry(data) {
					var currentDate = new Date(data.created);
					currentDate.setHours(0,0,0,0);
					data.desc = changeTypeDesc[data.changeType];

					// Some values should get displayed differently then they get saved
					// for them a special function can get defined which returns the
					// value to display
					if (data.desc.hasOwnProperty('valueDisplayFunction')) {
						data.desc.valueDisplayFunctionFields.forEach(function(fieldName) {
							data[fieldName] = data.desc.valueDisplayFunction(data[fieldName], fieldName);
						});
					} else {
						data.desc.fields.forEach(function(fieldData) {
							if (!data[fieldData.key]) {
								data[fieldData.key] = '<EMPTY>';
							}
						});
					}

					if(scope.lastLogDate === null || currentDate.toString() !== scope.lastLogDate.toString()) {
						data.showLabel = true;
						scope.lastLogDate = currentDate;
						data.currentDate = currentDate;
					} else {
						data.showLabel = false;
					}

					if(data.changeType.includes('Draft') || data.changeType.includes('Value')){
						var oldValue = '';
						if(data.oldValue !== '<EMPTY>'){
							oldValue = data.oldValue;
						}

						var currentValue = '';
						if(data.value !== '<EMPTY>'){
							currentValue = data.value;
						}

						var diff = JsDiff.diffChars(oldValue, currentValue);
						var fragment = document.createElement('div');

						for (var i=0; i < diff.length; i++) {

							if (diff[i].added && diff[i + 1] && diff[i + 1].removed) {
								var swap = diff[i];
								diff[i] = diff[i + 1];
								diff[i + 1] = swap;
							}
					
							var node;
							if (diff[i].removed) {
								node = document.createElement('del');
								node.appendChild(document.createTextNode(diff[i].value));
							} else if (diff[i].added) {
								node = document.createElement('ins');
								node.appendChild(document.createTextNode(diff[i].value));
							} else {
								node = document.createTextNode(diff[i].value);
							}
							fragment.appendChild(node);
						}

						data.valueDiff = fragment.innerHTML;
					}

					return data;
				};



				/**
				 * Get all the available languages from the server
				 */
				scope.fetchAvailableLanguages = function (callback) {
					AvailableLanguages.get(function success (response) {
						callback(null, response);
					}, function failure(errorResponse) {
						callback(errorResponse);
					});
				};


				/**
				 * Returns the full language name for the given language code
				 * if available
				 */
				scope.getLanguageName = function(languageCode) {
					if (scope.allLanguages && scope.allLanguages.hasOwnProperty(languageCode)) {
						return scope.allLanguages[languageCode];
					}

					return languageCode;
				};


				/**
				 * Return the short context-description for the given change-log-entry
				 */
				scope.getChangeContext = function(logData) {
					var returnData = '';

					if (logData.hasOwnProperty('languageName') && logData.languageName) {
						returnData += 'in ';
						if (logData.languageName === 'ALL') {
							returnData += '<strong>All Languages</strong>';
						} else {
							returnData += '<strong>' + scope.getLanguageName(logData.languageName) + '</strong>';
						}
					}

					var additionalProperties = {
						'key': 'with ID',
						'groupName': 'in Group',
						'tagName': 'with Tag'
					};

					// If there are overwrites for the log-type apply them
					if (changeTypeDesc[logData.changeType].hasOwnProperty('contextOverwrite')) {
						for (var propertyName in changeTypeDesc[logData.changeType].contextOverwrite) {
							additionalProperties[propertyName] = changeTypeDesc[logData.changeType].contextOverwrite[propertyName];
						}
					}

					for (var propertyName in additionalProperties) {
						if (logData.hasOwnProperty(propertyName) && logData[propertyName]) {
							var glueWords = additionalProperties[propertyName];
							if (returnData !== '') {
								returnData += ' ';
							}
							returnData += glueWords + ' <strong>' + logData[propertyName] + '</strong>';
						}
					}

					return returnData;
				};

				scope.clipboardText = "Copy";
				scope.copyToClipboard = function(textToCopy){
					var copyTextArea = document.createElement("textarea");
					copyTextArea.value = textToCopy;
					document.body.appendChild(copyTextArea);

					copyTextArea.select();

					try {
						var successful = document.execCommand('copy');
						var msg = 'Copied!';
						if(!successful){
							msg = 'Whoops, not copied!';
						}
						scope.clipboardText = msg;
						$timeout(function(){
							scope.clipboardText = "Copy";
						}, 550);
					} catch (err) {
						console.log('Oops, unable to copy');
					}
					
					document.body.removeChild(copyTextArea);
				};

				/**
				 * Initialize the directive
				 */
				scope.init = function () {
					scope.fetchAvailableLanguages(function(error, allLanguages) {
						scope.allLanguages = allLanguages;
						scope.fetchMoreData();
					});

					initFilters();
				};


				scope.init();
			}
		};
	}]);
